module.exports = __webpack_public_path__ + "img/emergency-fund.5c1337ba.svg";